export default __webpack_public_path__ + "static/Asset 14@300x-1a33e6eebffb856aa3325f406b0508fe.png";